export default __webpack_public_path__ + "static/media/harshit-prof.749c9043.jpg";